export default "__VITE_ASSET__d5c633ec__"